var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { DateTimeHelper } from '../../../helpers/date-time-helper';
import { transient, autoinject } from "aurelia-dependency-injection";
import { CloneUtility } from "../../../utilities/clone";
import { DataType } from '../../../models/queries/queries.models';
import { DialogClientService } from "../../../services/basics/dialog-client.service";
import * as Enumerable from 'linq';
var ManageColumnsDialog = /** @class */ (function () {
    function ManageColumnsDialog(dialogClientService) {
        this.dialogClientService = dialogClientService;
        this.selected = "panel-columns";
    }
    ManageColumnsDialog.prototype.activate = function (model) {
        if (model) {
            this.model = model;
            this.columns = CloneUtility.cloneObject(model.columns);
            this.resetColumns();
        }
    };
    ManageColumnsDialog.prototype.select = function (item) {
        this.selected = item;
    };
    ManageColumnsDialog.prototype.save = function () {
        this.columns.forEach(function (column) {
            if ((column.dataType === DataType.Date || column.dataType === DataType.DateTime) && !column.valueConverter) {
                column.valueConverter = function (value) { return value ? DateTimeHelper.getFormattedDate(new Date(value)) + " " + (new Date(value).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })) : ""; };
            }
        });
        this.model.columns = this.columns;
        this.model.reloadData();
        this.model.onSaveManageColumns();
        this.dialogClientService.hide();
    };
    ManageColumnsDialog.prototype.cancel = function () {
        this.dialogClientService.hide();
    };
    ManageColumnsDialog.prototype.setSelectedAvailableColumn = function (column) {
        this.selectedAvailableColumn = column;
    };
    ManageColumnsDialog.prototype.setSelectedVisibleColumn = function (column) {
        this.selectedVisibleColumn = column;
    };
    ManageColumnsDialog.prototype.moveColumnRight = function (column) {
        if (column) {
            column.isHidden = false;
            ;
        }
        this.resetColumns();
    };
    ManageColumnsDialog.prototype.moveSortingRight = function (column) {
        if (column) {
            column.isSortable = true;
            column.isAscending = true;
        }
        this.resetColumns();
    };
    ManageColumnsDialog.prototype.moveGroupingRight = function (column) {
        if (column) {
            column.isGrouping = true;
        }
        this.resetColumns();
    };
    ManageColumnsDialog.prototype.moveColumnLeft = function (column) {
        if (column) {
            column.isHidden = true;
            ;
        }
        this.resetColumns();
    };
    ManageColumnsDialog.prototype.moveSortingLeft = function (column) {
        if (column) {
            column.isSortable = false;
            ;
        }
        this.resetColumns();
    };
    ManageColumnsDialog.prototype.moveGroupingLeft = function (column) {
        if (column) {
            column.isGrouping = false;
            ;
        }
        this.resetColumns();
    };
    ManageColumnsDialog.prototype.moveSortingDown = function () {
        var _this = this;
        if (this.selectedVisibleColumn) {
            this.fixSortOrder();
            var list = Enumerable.from(this.visibleSorting);
            if (this.selectedVisibleColumn.sortOrder !== (this.visibleSorting.length - 1)) {
                var next = list.first(function (x) { return x.sortOrder === (_this.selectedVisibleColumn.sortOrder + 1); });
                next.sortOrder -= 1;
                this.selectedVisibleColumn.sortOrder += 1;
            }
        }
        this.resetColumns();
    };
    ManageColumnsDialog.prototype.moveGroupingDown = function () {
        var _this = this;
        if (this.selectedVisibleColumn) {
            this.fixGroupOrder();
            var list = Enumerable.from(this.visibleGrouping);
            if (this.selectedVisibleColumn.groupOrder !== (this.visibleGrouping.length - 1)) {
                var next = list.first(function (x) { return x.groupOrder === (_this.selectedVisibleColumn.groupOrder + 1); });
                next.groupOrder -= 1;
                this.selectedVisibleColumn.groupOrder += 1;
            }
        }
        this.resetColumns();
    };
    ManageColumnsDialog.prototype.moveSortingUp = function () {
        var _this = this;
        if (this.selectedVisibleColumn) {
            this.fixSortOrder();
            var list = Enumerable.from(this.visibleSorting);
            if (this.selectedVisibleColumn.sortOrder !== 0) {
                var prev = list.first(function (x) { return x.sortOrder === (_this.selectedVisibleColumn.sortOrder - 1); });
                prev.sortOrder += 1;
                this.selectedVisibleColumn.sortOrder -= 1;
            }
        }
        this.resetColumns();
    };
    ManageColumnsDialog.prototype.moveGroupingUp = function () {
        var _this = this;
        if (this.selectedVisibleColumn) {
            this.fixGroupOrder();
            var list = Enumerable.from(this.visibleGrouping);
            if (this.selectedVisibleColumn.groupOrder !== 0) {
                var prev = list.first(function (x) { return x.groupOrder === (_this.selectedVisibleColumn.groupOrder - 1); });
                prev.groupOrder += 1;
                this.selectedVisibleColumn.groupOrder -= 1;
            }
        }
        this.resetColumns();
    };
    ManageColumnsDialog.prototype.moveColumnUp = function () {
        var _this = this;
        if (this.selectedVisibleColumn) {
            this.fixColumnOrder();
            var list = Enumerable.from(this.visibleColumns);
            if (this.selectedVisibleColumn.columnOrder !== 0) {
                var prev = list.first(function (x) { return x.columnOrder === (_this.selectedVisibleColumn.columnOrder - 1); });
                ;
                prev.columnOrder += 1;
                ;
                this.selectedVisibleColumn.columnOrder -= 1;
                ;
            }
        }
        this.resetColumns();
    };
    ManageColumnsDialog.prototype.moveColumnDown = function () {
        var _this = this;
        if (this.selectedVisibleColumn) {
            this.fixColumnOrder();
            var list = Enumerable.from(this.visibleColumns);
            if (this.selectedVisibleColumn.columnOrder !== (this.visibleColumns.length - 1)) {
                var next = list.first(function (x) { return x.columnOrder === (_this.selectedVisibleColumn.columnOrder + 1); });
                ;
                next.columnOrder -= 1;
                ;
                this.selectedVisibleColumn.columnOrder += 1;
                ;
            }
        }
        this.resetColumns();
    };
    ManageColumnsDialog.prototype.fixColumnOrder = function () {
        var e_1, _a;
        try {
            for (var _b = __values(this.visibleColumns), _c = _b.next(); !_c.done; _c = _b.next()) {
                var x = _c.value;
                x.columnOrder = this.visibleColumns.indexOf(x);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    ManageColumnsDialog.prototype.fixSortOrder = function () {
        var e_2, _a;
        try {
            for (var _b = __values(this.visibleSorting), _c = _b.next(); !_c.done; _c = _b.next()) {
                var x = _c.value;
                x.sortOrder = this.visibleSorting.indexOf(x);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    ManageColumnsDialog.prototype.fixGroupOrder = function () {
        var e_3, _a;
        try {
            for (var _b = __values(this.visibleGrouping), _c = _b.next(); !_c.done; _c = _b.next()) {
                var x = _c.value;
                x.groupOrder = this.visibleGrouping.indexOf(x);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    ManageColumnsDialog.prototype.resetColumns = function () {
        var enumerable = Enumerable.from(this.columns);
        this.availableColumns = enumerable.where(function (x) { return typeof x.isHidden === "function" ? true : x.isHidden; }).orderBy(function (x) { return x.columnOrder; }).toArray();
        this.availableSorting = enumerable.where(function (x) { return !x.isSortable; }).orderBy(function (x) { return x.sortOrder; }).toArray();
        this.availableGrouping = enumerable.where(function (x) { return !x.isGrouping; }).orderBy(function (x) { return x.groupOrder; }).toArray();
        this.visibleColumns = enumerable.where(function (x) { return !x.isHidden; }).orderBy(function (x) { return x.columnOrder; }).toArray();
        this.visibleSorting = enumerable.where(function (x) { return x.isSortable; }).orderBy(function (x) { return x.sortOrder; }).toArray();
        this.visibleGrouping = enumerable.where(function (x) { return x.isGrouping; }).orderBy(function (x) { return x.groupOrder; }).toArray();
    };
    ManageColumnsDialog = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [DialogClientService])
    ], ManageColumnsDialog);
    return ManageColumnsDialog;
}());
export { ManageColumnsDialog };
